module.exports = __webpack_public_path__ + "img/git.e17d9d39.svg";